(function ($) {

  function popup(url, title, size) {
    var w = size[0] || 640;
    var h = size[1] || 480;

    console.log(size);

    var dualScreenLeft = (window.screenLeft != undefined) ? window.screenLeft : screen.left;
    var dualScreenTop = (window.screenTop != undefined) ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
    var sharePopup = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    if (sharePopup && sharePopup.focus) {
      sharePopup.focus();
    }
  }

  function initialize() {
    $(document).on('click', '[data-share="popup"]', function (event) {
      event.preventDefault();

      var $this = $(this);

      var url = $this.attr('href');
      var title = $this.attr('title');

      var size = $this.attr('data-share-size');
      size = size ? size.split(',') : false;

      popup(url, title, size);

      return false;
    });
  }

  $(function () {
    initialize();
  });

})(jQuery);
